// extracted by mini-css-extract-plugin
export default {"switch":"custom-switch_switch__RtfSo"};